module.exports = __webpack_public_path__ + "img/web-bg.3a871c08.svg";